import { action } from 'typesafe-actions';

import { IShopConfig, ShopConfigTypes } from './types';

export const loadRequest = () => action(ShopConfigTypes.LOAD_REQUEST);
export const loadSuccess = (data: IShopConfig) => action(ShopConfigTypes.LOAD_SUCCESS, data);
export const loadFailure = () => action(ShopConfigTypes.LOAD_FAILURE);
